var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-container"},[(_vm.preview)?_c('img',{staticClass:"preview",class:{ 'portrait': _vm.label && _vm.label.portrait_mode, 'invalid': !_vm.labelValid },attrs:{"src":_vm.preview,"alt":"Preview"}}):_c('div',{staticClass:"no-preview",class:{ 'invalid': !_vm.labelValid }})])
}
var staticRenderFns = []

export { render, staticRenderFns }